import { render, staticRenderFns } from "./Pass.vue?vue&type=template&id=4f5da750&"
import script from "./Pass.vue?vue&type=script&lang=js&"
export * from "./Pass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports